import { useQuery } from "@tanstack/react-query";
import { DraftNoteDto, UserProfileDto, UserRole } from "@green0meter/api-client";

import { DOMAIN_FORM_SUBMISSIONS } from "../domain";

import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { submissionsApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_GET_FORM_DRAFT_NOTE = "GET_FORM_DRAFT_NOTE";

const allowedRoles = [
  UserRole.Owner,
  UserRole.Manager,
  UserRole.Respondent,
  UserRole.Viewer,
  UserRole.Auditor,
];

export const fetchFormDraftNote = async (
  formId: string,
): Promise<DraftNoteDto[] | undefined> => {
  const response =
    await submissionsApi.submissionsControllerGetFormDraftNote(formId);

  return response.data;
};

export const useGetFormDraftNote = (
  user: UserProfileDto | null,
  formId: string,
): {
  formDraftNote?: DraftNoteDto[];
  formDraftNoteEnabled: boolean;
  formDraftNoteError: Error | null;
  isLoadingFormDraftNote: boolean;
  isFetchingFormDraftNote: boolean;
  isSuccessFormDraftNote: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const { data, error, isLoading, isFetching, isSuccess } = useQuery<
    DraftNoteDto[] | undefined,
    Error
  >({
    queryKey: [DOMAIN_FORM_SUBMISSIONS, ACTION_GET_FORM_DRAFT_NOTE, formId],
    queryFn: () => fetchFormDraftNote(formId),
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled,
  });

  return {
    formDraftNote: data,
    formDraftNoteEnabled: enabled,
    formDraftNoteError: error,
    isLoadingFormDraftNote: isLoading,
    isFetchingFormDraftNote: isFetching,
    isSuccessFormDraftNote: isSuccess,
  };
};
